import {
  barchart,
  piechart,
  donut,
  halfdonut,
  linechart,
  scatterchart,
  treemapchart,
  stackedbarchart,
  stackedareachart,
  pyramidchart,
} from './charts/index.js';

let charts = [
  barchart,
  stackedbarchart,
  linechart,
  piechart,
  donut,
  halfdonut,
  stackedareachart,
  scatterchart,
  treemapchart,
  pyramidchart,
];

export default charts;
